import { defineComponent } from 'vue';
import documentListItem from '@/components/list/documentListItem.vue';
import ListWrapper from './listWrapper.vue';
import { getDocumentList } from '@/api/api';
import utils from '@/public/utils/index';
export default defineComponent({
    props: {
        size: {
            default: '',
            type: String
        },
        moduleId: {
            type: Number
        },
        subDepId: {
            type: Number
        },
        diseaseId: {
            type: Number
        },
        flagBl: {
            type: Boolean,
            default: false
        },
        labelId: {
            default: 0
        },
        labelType: {
            default: 'root'
        }
    },
    data() {
        return {
            list: [],
            pageNo: 1,
            flag: true,
            pageCount: 1
        };
    },
    watch: {
        flagBl(newData) {
            if (newData) {
                this.pageNo = 1;
                this.getList();
            }
        }
    },
    methods: {
        getList() {
            getDocumentList({
                params: {
                    userId: utils.getUserId()
                },
                query: {
                    pageNo: this.pageNo,
                    pageSize: 10,
                    labelId: this.labelId,
                    labelType: this.labelType
                }
            }).then(res => {
                this.flag = true;
                this.$hideLoading();
                if (res.code === 200) {
                    if (this.pageNo === 1) {
                        this.list = res.data.list;
                        this.$emit('initFlag');
                    }
                    else {
                        this.list = this.list.concat(res.data.list);
                    }
                    this.pageCount = res.data.pageCount;
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        showMore() {
            if (this.flag) {
                this.pageNo = this.pageNo + 1;
                this.flag = false;
                this.$showLoading();
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        }
    },
    components: {
        documentListItem,
        ListWrapper
    }
});
